import React, { useState } from 'react';
import { FiChevronDown, FiChevronLeft, FiChevronRight, FiChevronUp } from 'react-icons/fi';
import { useAuth } from '../../hooks/useAuth';
import './Header.css';

interface HeaderProps {
  onMenuToggle: () => void;
  isSidebarOpen: boolean;
  isSidebarCollapsed: boolean;
  isDesktop: boolean;
  currentPage: string;
  onPageChange: (page: string) => void;
}

const PAGE_TITLES: Record<string, string> = {
  dashboard: '대시보드',
  exam: '시험 응시',
  results: '시험 결과',
  board: '게시판',
  ranking: '랭킹',
  cohorts: '스터디 기수',
  profile: '프로필',
  'user-management': '사용자 관리',
  'question-bank-management': '문제 은행',
  'exam-type-management': '시험 유형',
  'question-management': '문제 관리',
  'report-management': '신고 관리',
  'coupon-management': '쿠폰 관리',
  'coupon-logs': '쿠폰 로그',
  'board-management': '게시판 관리',
  'achievement-management': '업적 관리',
  'exam-monitoring': '시험 모니터링',
  'analytics-dashboard': '운영 분석'
};

const Header: React.FC<HeaderProps> = ({
  onMenuToggle,
  isSidebarOpen,
  isSidebarCollapsed,
  isDesktop,
  currentPage,
  onPageChange
}) => {
  const { user, logout } = useAuth();
  const title = PAGE_TITLES[currentPage] || 'AWS Exam Practice';
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const menuLabel = isDesktop
    ? (isSidebarCollapsed ? '사이드바 펼치기' : '사이드바 접기')
    : (isSidebarOpen ? '메뉴 닫기' : '메뉴 열기');

  const handleQuickNav = (page: string) => {
    onPageChange(page);
    setIsUserMenuOpen(false);
  };

  return (
    <header className="header-v2">
      <div className="header-v2__container">
        <div className="header-v2__left">
          <button
            className="header-v2__menu-toggle"
            onClick={onMenuToggle}
            aria-label={menuLabel}
            title={menuLabel}
          >
            {isDesktop ? (
              <span className="header-v2__toggle-icon" aria-hidden="true">{isSidebarCollapsed ? <FiChevronRight /> : <FiChevronLeft />}</span>
            ) : (
              <span className={`header-v2__hamburger ${isSidebarOpen ? 'header-v2__hamburger--open' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            )}
          </button>

          <div className="header-v2__brand-mark" aria-hidden="true">AWS</div>

          <div className="header-v2__title-wrap">
            <span className="header-v2__eyebrow">AWS Exam Practice</span>
            <h1 className="header-v2__title">{title}</h1>
          </div>
        </div>

        <div className="header-v2__right">
          <div className="header-v2__user-chip">
            <img
              src={user?.profile_picture || '/default-avatar.svg'}
              alt=""
              className="header-v2__avatar"
              onError={(event) => {
                event.currentTarget.src = '/default-avatar.svg';
              }}
            />
            <button
              className="header-v2__user-trigger"
              onClick={() => setIsUserMenuOpen((prev) => !prev)}
              aria-expanded={isUserMenuOpen}
            >
              <span className="header-v2__user-info">
                <span className="header-v2__user-name">{user?.name || '사용자'}</span>
                <span className="header-v2__user-role">{user?.is_admin ? '관리자' : '회원'}</span>
              </span>
              <span className="header-v2__caret" aria-hidden="true">{isUserMenuOpen ? <FiChevronUp /> : <FiChevronDown />}</span>
            </button>

            {isUserMenuOpen && (
              <div className="header-v2__user-menu">
                <button onClick={() => handleQuickNav('profile')}>내 정보</button>
                <button className="danger" onClick={logout}>로그아웃</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
